import React, { useMemo } from "react";
import WalletService from "../../services/WalletService";
import apiClient from "../../auth/apiClient";
import { useStyles } from "../../pages/OnePass/styles";
import googleWalletBadge from "../../assets/google-wallet-badge.svg";

const GoogleWalletButton = ({ identifier }) => {
  const classes = useStyles();
  const walletService = useMemo(() => new WalletService(apiClient), []);

  const handleGoogleWalletClick = async () => {
    try {
      const response = await walletService.createGoogleWalletPass(identifier);
      const url = response.data;
      const link = document.createElement("a");
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download Google Wallet pass:", error);
    }
  };

  return (
    <button
      type="button"
      className={classes.walletBadgeWrapper}
      onClick={handleGoogleWalletClick}
      aria-label="Add to Google Wallet"
    >
      <img
        src={googleWalletBadge}
        alt="Add to Google Wallet"
        className={classes.walletBadge}
      />
    </button>
  );
};

export default GoogleWalletButton;

